<template>
      <div class='lands' :class="{ disabled: !actLpoIsDraft }">
        <PlotsVisualLandTax/>
        <table class='table-distribution table-common'>
          <thead>
            <tr>
              <th>Квартал</th>
              <th>Выдел</th>
              <th>ЛП выдел</th>
              <th>Площадь ЛП выдела</th>
              <th>Состояние насаждений</th>
              <th>Причина повреждения</th>
              <th>Дата съемки</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lpo, i in deshifResults" :key="lpo.lpo_id">
              <td>{{ lpo.area }}</td>
              <td>{{ lpo.section }}</td>
              <td>{{ lpo.section_lp }}</td>
              <td>{{ lpo.s_lp}}</td>
              <td>
                <select v-model="lpo.condition_id">
                  <option  v-for="item in remoteConditions" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
              </td>
              <td>
                <select v-model="lpo.damage_id">
                  <option v-for="item in remoteDamages" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
              </td>
              <td>
                <input type='date' v-model='lpo.image_date' />
              </td>
            </tr>
          </tbody>
        </table>
        
        
        <input class="add-block-btn-row" @click="saveRecount(deshifResults)" type="button" value="Сохранить" :disabled="!needToSaveChanges"/>
      </div>
  </template>

    
  
  <script>
  import { mapState, mapActions } from "vuex";
  
  const ROOT_API = process.env.VUE_APP_ROOT_API;
  
  const GET_AREAS = ROOT_API + "address/get_areas.php";
  const GET_SECTIONS = ROOT_API + "address/get_sections.php";
  const RECOUNT = ROOT_API + 'get_site_data/recount.php';
  import requestToApi from "@/lib/requestToApi";
  import PlotsVisualLandTax from '../Recount__visualLand/RecountVisualLand__tax';
  
  export default {
    name: "DeshifResults",
    components: {
			PlotsVisualLandTax
		},
    data() {
      return {
        deshifResultsDB: [],
        deshifResults: [],
        addMode: false,
  
        forestry: null,
  
        selectedArea: null,
        selectedSection: null,
        isLpSection: false,
        selectedSectionLp: null,
  
        areaList: [],
        sectionList: [],
  
        selectedList: [],
  
        lpoToRemove: null,
        removeConfirmationOpen: false,
      };
    },
    created() {
      this.updateRemoteRecount();
      //this.deshifResults = a;
      //console.log(a);
			const catalogs = [ 'info_damage_reason_groups', 'info_remote_condition'];
			this.loadCatalogs(catalogs);


		},
    computed: {
      needToSaveChanges() {
          for (let i = 0; i < this.deshifResults.length; i++) {
            if (!this.objectsIsDeepEqual(this.deshifResults[i], this.deshifResultsDB[i])) {
              return true;
            }
          }
          return false;
      },
      actLpoIsDraft() {
        return this.$store.getters["lpoData/actLpoIsDraft"];
      },
      ...mapState("selectedLpo", {
        lpo: (state) => state.lpo,
      }),
      ...mapState("selectedLpo/recount", {
        remoteListRecount: (state) => state.remoteListRecount
      }),
      ...mapState("lpoData", {
        currentLpo: (state) => state.currentLpo,
        actLpoList: (state) => state.actLpoList,
      }),
      ...mapState({
				remoteDamages: state => state.catalogs.info_damage_reason_groups,
        remoteConditions: state => state.catalogs.info_remote_condition,
        remoteImageModes: state => state.catalogs.info_remote_image_mode
			})
    },
    watch: {
      selectedArea(area) {
        if (area) {
          this.getSectionList();
        }
      },
    },
    methods: {
      ...mapActions( ["loadCatalogs"]),
      ...mapActions("selectedLpo/recount", ["setRemoteListRecount"]),
      async updateRemoteRecount() {
        let params = {
            url: RECOUNT,
            params: {lpo_id: this.lpo.lpo_id}
        }
        const data = await requestToApi(params);
        this.deshifResultsDB = JSON.parse(JSON.stringify(data));
        this.deshifResults = data;
      },
      async saveRecount(deshifResults) {
        const result = await this.setRemoteListRecount(deshifResults);
        if (result.code == 0) {
          this.updateRemoteRecount();
        } else {
          alert("ошибка сохранения: " + result.name)
        }
      },
      objectsIsDeepEqual(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);

        if (objKeys1.length !== objKeys2.length) return false;

        for (var key of objKeys1) {
          const value1 = object1[key];
          const value2 = object2[key];

          const isObjects = this.isObject(value1) && this.isObject(value2);

          if ((isObjects && !isDeepEqual(value1, value2)) ||
            (!isObjects && value1 !== value2)
          ) {
            return false;
          }
        }
        return true;
        
      },
      isObject(object) {
        return object != null && typeof object === "object";
      },
    }
  };
  </script>
  
  <style scoped src="@/style/wrapper.css"></style>
  <style scoped src="@/style/grid.css"></style>
  <style scoped src="@/style/input.css"></style>
  
  <style scoped>
  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  .btn-row {
    margin-bottom: 20px;
  }
  
  .control-btn-row > button {
    margin-right: 10px;
  }
  
  .add-block {
    background-color: #eee;
    padding: 20px 20px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }
  
  .add-block-btn-row {
    margin-top: 10px;
  }
  
  .lpos-data {
    padding-top: 30px;
  }
  
  .title-block {
    font-size: 20px;
    font-family: "roboto black";
  
    margin-bottom: 40px;
  }
  
  .lpos-table {
    width: 100%;
    font-size: 14px;
  }
  
  .lpos-table th {
    font-weight: bold;
    padding: 6px;
  }
  
  .lpos-table td {
    border-top: 1px solid #aaa;
    padding: 6px;
    //text-align: center;
    vertical-align: middle;
  }
  </style>